const PaginationConfig = {
    paginationSize: 10,
    pageStartIndex: 1,
    withFirstAndLast: true,
    showTotal: true,
    firstPageText: 'First',
    prePageText: 'Previous',
    nextPageText: 'Next',
    lastPageText: 'Last',
    sizePerPageList: [
        {
            text: '10',
            value: 10,
        },
        {
            text: '25',
            value: 25,
        },
        {
            text: '50',
            value: 50,
        },
    ],
};

export {
    PaginationConfig,
}
